export const CourseData = `
  id
  name
  shortName
  description
  isActive
  numberOfSession
  sessionHour
  optional
  courseLineForUpdate
  courseTopic
  courseLine
`;
